export default {
  path: '/relatorios-de-amostragem',
  component: () =>
    import('@/components/pages/SamplingReports/SamplingReports.vue')
}
